<template>
  <div class="home-query-product">
    <div class="two-join-box item-space">
      <input-style-box label="起运地"
                       class="join-box-item"
                       style="width: 245px;margin-right: 12px;"
                       :focus-status.sync="focusStatus.start">
        <select-place-template v-model="startPlace"
                               :list="startPlaceList"
                               :is-loading="startPlaceLoading"
                               filter-hot
                               :clearable="false"
                               @change="changeStartPlace"
                               @focus="focusAndBlur('start',true)"
                               @blur="focusAndBlur('start',false)"
                               class="select-place-item"></select-place-template>
      </input-style-box>
      <!--<div class="join-space">
        <span class="join-space&#45;&#45;icon"><i class="el-icon-right"></i></span>
      </div>-->
      <input-style-box label="目的国"
                       class="join-box-item"
                       style="width: 245px;"
                       :focus-status.sync="focusStatus.country">
        <select-place-template4
          ref="endCountry"
          v-model="endPlace"
          :tab-head-list="continentCountryTabHeadList"
          :default-tab-value.sync="continentCountryDefaultTabValue"
          :data="continentCountryDataset"
          :is-loading="continentCountryLoading"
          filter-hot
          filter-other-tabs
          @change="changeEndPlace"
          @focus="focusAndBlur('country',true)"
          @blur="focusAndBlur('country',false)"
          popover-width="600"
          placeholder="请选择目的国家"
          class="select-place-item"
          :clearable="false"
        />
      </input-style-box>
    </div>
    <input-style-box :label="destinationLabelText"
                     class="item-space"
                     style="width: 200px"
                     :focus-status.sync="focusStatus.warehouse || endWarehouseVisiblePopover">
      <select-place-template3
        ref="selectPlace3"
        v-model="endWarehouseSelectList"
        :tab-head-list="destinationListGroupTabConfig"
        :default-tab-value.sync="destinationDefaultTabValue"
        :data="destinationListGroupData"
        @change="changeEndWarehouse"
        @clear="clearEndWarehouse"
        @focus="focusAndBlur('warehouse',true)"
        @blur="focusAndBlur('warehouse',false)"
        :is-loading="endWarehouseLoading"
        :disabled="!endPlace.id"
        :placeholder="endWarehousePlaceholder"
        class="select-place-item"
        :multiple="false"
        select-all-button
        :visible.sync="endWarehouseVisiblePopover"
        :clearable="false"
      >
        <template
          v-if="destinationDefaultTabValue === 'noFba' && endWarehouseVisiblePopover"
          slot="content"
          class=""
        >
          <search-select-zip-code
            :is-query="endPlace.privateAddressType !== 3 "
            :btn-text="endPlace.privateAddressType === 3 ? '确认' : '搜索'"
            :country-id="endPlace.id"
            @change="handlerInputZipCode"
          />
        </template>
      </select-place-template3>
    </input-style-box>
    <input-style-box label="货物信息"
                     class="item-space"
                     style="width: 240px;"
                     :focus-status.sync="focusStatus.goodsType">
      <search-select-good
        :list="goodsTypeList"
        :productList="goodsNameList"
        v-model="selectGoodTypeAndName"
        :countryId="endPlace.id"
        :disabled="!endPlace.id"
        @remoteMethod="remoteMethodProductName"
        @focus="focusAndBlur('goodsType',true)"
        @blur="focusAndBlur('goodsType',false)"
        class="select-place-item"
        @change="goodInfoChange"
        :clearable="false"
      >
      </search-select-good>
      <!--<el-select
        v-model="goodsType"
        :placeholder="endPlace.id?'选择货物类型':'请先选择国家'"
        size="normal"
        class="select-input-box hide-select-arrow"
        clearable
        filterable
        :loading="goodsTypeListLoading"
        :disabled="!endPlace.id"
        @focus="handlerSelectDown(true),focusAndBlur('goodsType',true)"
        @blur="focusAndBlur('goodsType',false)"
      >
        <el-option
          v-for="item in goodsTypeList"
          :key="item.goodsTypeId"
          :label="item.goodsTypeName"
          :value="item.goodsTypeId"
        />
      </el-select>-->
    </input-style-box>
    <input-style-box label="商品名称(选填)"
                     class="item-space"
                     v-if="false"
                     :focus-status.sync="focusStatus.goodsName">
      <!-- <el-select
        v-model="goodsNameCurrent"
        :placeholder="endPlace.id?'请输入品名':'请先选择国家'"
        size="normal"
        class="text-input-box"
        clearable
        filterable
        remote
        :loading="goodsNameLoading"
        :disabled="!endPlace.id"
        :remote-method="remoteMethodProductName"
        @focus="handlerSelectDown(true),focusAndBlur('goodsName',true)"
        @blur="focusAndBlur('goodsName',false)"
      >
        <div v-if="goodsNameList.length">
          <el-option
            v-for="(item,index) in goodsNameList"
            :key="index"
            :label="item.goodsName"
            :value="item.goodsName"
          >
            <div style="width: 200px">
              <span style="float: left">{{ item.goodsName }}</span>
              <span style="float: right; font-size: 13px">
                <span style="color: #999;">加收</span>
                <span style="color: #FF4D01;">
                  {{ item.price || 0 }} {{ item.currency || "-" }}/{{item.priceUnit || "-"}}
                </span>
              </span>
            </div>
          </el-option>
        </div>
        <div slot="empty" class="empty-select">
          抱歉，暂未找到相关商品名
        </div>
      </el-select> -->
      <goods-select
        ref="goodsSelect"
        v-model="goodsNameCurrent"
        :placeholder="endPlace.id?'请输入选择':'请先选择目的地'"
        :productList="goodsNameList"
        :loading="goodsNameLoading"
        :disabled="!endPlace.id"
        :countryId="endPlace.id"
        :is-loading="goodsNameLoading"
        @remoteMethod="remoteMethodProductName"
        @change="(val) => { goodsNameCurrent = val }"
        @focus="goodsNameList = []; handlerSelectDown(true),focusAndBlur('goodsName',true)"
        @blur="focusAndBlur('goodsName',false)">
      </goods-select>
    </input-style-box>
    <!-- <input-style-box label="关键词"
                     class="item-space"
                     style="width: 327px"
                     :focus-status.sync="focusStatus.goodsName">
      <select-keyword
        :list="hotSearchNameList"
        :is-loading="hotSearchLoading"
        v-model="selectedHotWords"
        @change="changeKeyword"
        @inputChange="keywordInput"
        class="select-place-item"
      ></select-keyword>
    </input-style-box> -->
    <el-button class="search-btn"
               type="primary"
               icon="el-icon-search"
               @click="clickSearch">{{ btnText }}</el-button>
  </div>
</template>

<script>
import InputStyleBox from "@/components/placeOrder/components/inputStyleBox";
import SelectPlaceTemplate from "../../../../../common/newSelectPlace/selectPlaceTemplate";
import {debounce, isObject} from "my-tools-kit";
import {
  checkInputZipCode,
  createPrivateAddressZipCodeList,
  disposeAePrivateDestinationInitialGroup,
  disposeDestinationList, disposePrivateCityList, handlerSelectDown
} from "@/assets/js/utils.selectPlace";
import SelectPlaceTemplate3 from "../../../../../common/newSelectPlace/selectPlaceTemplate3";
import SearchSelectZipCode from "../../../../../common/newSelectPlace/searchSelectZipCode";
import goodsSelect from '@common/goods-select'
import SelectPlaceTemplate4 from "../../../../../common/newSelectPlace/selectPlaceTemplate4";
import {getLocalId, sendCustomerOperationRecord, sendStatisticHotCountry} from "@/assets/js/utils";
import selectKeyword from "../../../../../common/newSelectPlace/selectKeyword.vue";
import searchSelectGood from "../../../../../common/newSelectPlace/searchSelectGood.vue";
export default {
  name: "homeQueryLogisticsProducts",

  components: {
    SelectPlaceTemplate4,
    SearchSelectZipCode, SelectPlaceTemplate3, SelectPlaceTemplate, InputStyleBox, goodsSelect,
    selectKeyword, searchSelectGood},
  props:{
    defaultProductType: { // 首页默认选中的物流产品类型tab：1-fba 2-海运专线 3-空运专线  4-陆运专线
      type: [String,Number],
      default: '1'
    },
    btnText:{ // 搜索按钮展示文本
      type:String,
      default:"查询",
    },
    // handlerSearchButton:Function,// 点击搜索按钮
  },
  data(){
    return {
      /* 输入样式框 获取焦点状态 */
      focusStatus:{
        start:false,
        country:false,
        warehouse:false,
        goodsType:false,//货物类型
        goodsName:false,//商品名称
      },
      /* 起运地 */
      startPlaceLoading:false,
      startPlace:{
        // id:"test1",
        // name:"test1",
      },
      startPlaceList:[],
      startPlaceVisiblePopover:false,
      /* 目的国 */
      endPlace:{
        // id:"test2",
        // name:"test2",
      },
      /* 七大洲分类国家列表 */
      continentCountryLoading:false,
      continentCountryDataset:{},//数据集
      continentCountryTabHeadList:[],
      continentCountryDefaultTabValue:"",// 目的地选择弹窗默认选中的tab
      /* 目的仓库 */
      endWarehouseLoading:false,
      // endWarehouse:{},//单选
      endWarehouseSelectList:[
        {namec:"全部",id:"all"},
      ],//多选
      endWarehouseList:[],//目的地分组列表(FBA)
      endWarehouseVisiblePopover:false,//目的仓库选择弹窗（未使用）
      privateCityList:[],//私人地址(城市)列表
      privateCityListLoading:false,
      zipCodeList:[],//私人地址(邮编)列表

      destinationDefaultTabValue:"fba",// 目的地选择弹窗默认选中的tab fba privateCity zipCode noFba
      /* 货物类型 */
      goodsType:"",
      goodsTypeList:[
        {goodsTypeName:"全部",goodsTypeId:""},
      ],
      goodsTypeListLoading: false,
      /* 产品(商品) */
      goodsNameCurrent: '',//名称
      goodsNameList: [],// 产品列表
      goodsNameLoading: false,
      transportTypeCode: {
        1: 'ALL',
        2: 'HY',
        3: 'KY',
        4: 'LY'
      },
      // 目的地类型  0全部，1fba, 2私人地址
      podlandType: 0,
      hotSearchNameList: [],
      hotSearchLoading: false,
      selectedHotWords: {},
      selectGoodTypeAndName: {goodstypeId: 0},
      keyword: '',
      goodNameInfo: {}
    }
  },
  computed: {
    /**
     * 目的地选择框展示的 placeholder 文本内容
     */
    endWarehousePlaceholder() {
      return this.endPlace.id ? '请选择目的地' : '请先选择国家'
    },
    /**
     * 目的地选择器label
     */
    destinationLabelText(){
      if(this.endPlace.id){
        if(String(this.defaultProductType) === '1') return "FBA仓";
        else if(this.endPlace.privateAddressType === 1) return "目的邮编";
        else if(this.endPlace.privateAddressType === 2) return "目的城市";
        // if(this.endPlace.code === "US") return "目的邮编开头";
        else if(this.endPlace.privateAddressType === 3) return "目的邮编";
        else return `目的地(${this.endPlace.privateAddressType})`;
      }
      return "目的地";
    },
    /**
     * 目的地分组列表数据
     */
    destinationListGroupTabConfig(){
      let list =  [];
      let fba = {
        label:"FBA仓库",
        value:"fba",// tab自身标识
        listLevel:2,// 列表的层级，只支持1和2
        showLeftLabel:true,// 2级列表是否显示左边的分组标签（展示首字母开头）
        openSelectAll:false,// 是否展示全选按钮
      };
      // let fbx = {label:"FBX仓库", value:"fbx", listLevel:2, showLeftLabel:true, openSelectAll:true, };
      let privateCity = {label:"非FBA仓(城市)", value:"privateCity", listLevel:2, showLeftLabel:true, openSelectAll:false, };
      let zipCode = {label:"非FBA仓(邮编)", value:"zipCode", listLevel:1, showLeftLabel:false, openSelectAll:false, };
      let inputZipCode = {label:"非FBA仓(邮编)", value:"noFba", listLevel:1,};

      list.push(fba);
      let country = this.endPlace;
      if(country.id){
        if(country.privateAddressType === 2){
          list.push(privateCity);
        }else{
          list.push(inputZipCode);
        }
        if(String(this.defaultProductType) === "1"){
          this.destinationDefaultTabValue = "fba";
        }else{
          if(country.privateAddressType === 2){
            this.destinationDefaultTabValue = "privateCity";
          }else{
            this.destinationDefaultTabValue = "noFba";
          }
        }
      }else{
        this.destinationDefaultTabValue = "fba";
      }

      // list.push(
      //   {label:"非FBA仓", value:"noFba", listLevel:1, },
      // )
      return list;
    },
    /**
     * 目的地分组列表数据
     */
    destinationListGroupData(){
      return {
        fba:this.endWarehouseList,
        // fbx:this.fbxList,
        zipCode:this.zipCodeList,
        privateCity:this.privateCityList,
      }
    },
  },
  watch:{
    defaultProductType(newValue){
      this.changeProductType(newValue);
    },
  },
  methods:{
    /**
     * 下拉框出现/隐藏时触发
     */
    handlerSelectDown,
    /**
     * 输入样式框 改变焦点状态
     */
    focusAndBlur(key="",isFocus=false){
      if(!key) return false;
      this.focusStatus[key] = isFocus;
    },
    /**
     * 切换物流产品类型
     */
    changeProductType(val){
      // 清空 选中的目的地
      this.endWarehouseSelectList = [
        {namec:"全部",id:"all"},
      ];

    },
    /**
     * 变更 起始地
     */
    changeStartPlace(value){
      this.startPlaceVisiblePopover = false;
      console.log("变更 起始地",value);
      let $endCountry = this.$refs.endCountry;
      if($endCountry && $endCountry.showListPopover){
        $endCountry.showListPopover();
      }
    },
    /**
     * 变更 目的国
     */
    changeEndPlace(data = {}){
      console.log("变更 目的国",Object.assign({},data));
      let countryId = data.id;
      // 目的仓库
      // this.endWarehouse = {};
      this.endWarehouseSelectList = [
        {namec:"全部",id:"all"},
      ];
      this.endWarehouseList = [];
      this.privateCityList = [];
      this.zipCodeList = [];

      // 货物类型
      this.goodsTypeList = [
        {goodsTypeName:"全部",goodsTypeId:""},
      ];
      this.goodsType = "";
      // 产品名称（商品名）
      this.goodsNameCurrent = ''
      this.goodsNameList = []

      this.getGoodsType(countryId);
      this.getEndWarehouseList(countryId);

      if (this.$refs.goodsSelect) {
        this.$refs.goodsSelect.hideListPopover()
        this.$refs.goodsSelect.selectItem(null)
      }
      if(data.privateAddressType === 2){
        this.getPrivateCityList(countryId);
      }else{
        this.getZipCodeList({
          country: data.namec||"",
          countryCode: data.code||"",
          countryId: countryId||"",
          privateAddressType:data.privateAddressType,
        })
      }

    },
    /**
     * 变更 目的仓库
     */
    changeEndWarehouse(value){
      console.log(value)
      if (value.length && value[0].id === 'all') {
        this.podlandType = 0
      } else {
        if (this.destinationDefaultTabValue === 'noFba') {
          this.podlandType = 2
        } else {
          this.podlandType = 1
        }
      }
    },
    clearEndWarehouse(value){
      // 目的仓库
      // this.endWarehouseSelectList = [
      //   {namec:"全部",id:"all"},
      // ];
    },
    /**
     * 选择手动输入邮编
     * @param item
     */
    selectInputZipCodeItem(item){
      this.endWarehouseSelectList = [item];
      if (this.destinationDefaultTabValue === 'noFba') {
        this.podlandType = 2
      } else {
        this.podlandType = 1
      }
      let $selectPlace3 = this.$refs.selectPlace3;
      if($selectPlace3 && $selectPlace3.hideListPopover) $selectPlace3.hideListPopover();
    },
    handlerInputZipCode(item){
      // let result = checkInputZipCode(text);
      // if(!result) {
      //   this.$message.error("邮编只能为1~5位数字或 12345-6789格式的9位邮编");
      //   return false
      // }
      let countryData = this.endPlace;
      let newItem = {
        // 目的国家
        country: countryData.namec||"",
        countryCode: countryData.code||"",
        countryId: countryData.id||"",
        privateAddressType:1,// 目的国家对应 私人地址派送类型 1:邮编 2：城市
        // 对应城市
        city: "",
        cityId: "",
        // fba 邮编
        id: item.id,
        namec: `${item.namec}`,
        namee: `${item.namec}`,
        isPrivateAddress:true,
        isPrivateAddressCity:false,
        _description:`私人地址(邮编)${item.namec}`,
      }
      this.selectInputZipCodeItem(newItem);
    },
    /**
     * 获取起运地列表
     */
    getStartPlaceList(){
      const data = {
      };
      const url = "/api/filedata/findAllFromCity";
      this.startPlaceLoading = true;
      return this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.startPlaceLoading = false;
          let list = res.datas||[];
          list = list.map(res=>{
            if(!isObject(res)) return undefined;
            return {
              code:res.code||"",
              list:res.fromCityDTOList||[],
            }
          });
          this.startPlaceList = list;
          return res
        })
        .catch(res=>{
          this.startPlaceLoading = false;
          this.startPlaceList = [];
          // return Promise.reject(res);
        })
    },
    /**
     * 根据七大洲分类获取所有国家列表
     */
    getContinentEndCountryList() {
      const data = {};
      const url = "/api/filedata/findContinentCountryList";
      this.continentCountryLoading = true;
      return this.axios.get(url, {params: data})
        .then(res => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.continentCountryLoading = false;
          let list = res.datas || [];
          let {defaultValue,tabHeadList,dataset} = this.createContinentEndCountryTabHeadList(list);
          // console.log('1==============',defaultValue,tabHeadList,dataset)
          this.continentCountryDefaultTabValue = defaultValue;
          this.continentCountryTabHeadList = tabHeadList;
          this.continentCountryDataset = dataset;
          return res
        })
        .catch(res => {
          this.continentCountryLoading = false;
          this.continentCountryDefaultTabValue = "";
          this.continentCountryTabHeadList = [];
          this.continentCountryDataset = {};
          // return Promise.reject(res);
        })
    },
    createContinentEndCountryTabHeadList(topList=[]){
      topList = this.continentListSort(topList, 'continentNameCn')
      let tabHeadList =  [];
      let defaultValue = "";
      let dataset = {};
      topList.forEach((item,index)=>{
        let id = `${item.continentId||""}`;
        if(!id) id = getLocalId();
        let namec = item.continentNameCn||"";
        let childList = item.countryInfoList||[];
        childList.forEach(twoItem=>{
          twoItem.continentNameCn = item.continentNameCn||"";
          twoItem.continentNameEn = item.continentNameEn||"";
          twoItem.privateAddressType = twoItem.privateAddressType || 1;
        })
        if(index === 0 ) defaultValue = id;
        let code = `${item.code||""}`;
        let opt = {
          label: namec,
          value: id,// tab自身标识
          listLevel:1,// 列表的层级，只支持1和2
          showLeftLabel:false,// 2级列表是否显示左边的分组标签（展示首字母开头）
          openSelectAll:false,// 是否展示全选按钮
        };
        if(!dataset[id]) {
          dataset[id] = childList;
          tabHeadList.push(opt);
        }
      })
      return {
        defaultValue,
        tabHeadList,
        dataset,
      }
    },
    /**
     * 获取 目的仓库列表
     */
    getEndWarehouseList(countryId){
      const data = {
        countryId,
      };
      const url = "/api/warehouse/getFBAAndPrivateWarehouseList";
      this.endWarehouseLoading = true;
      return this.axios.get(url, {params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.endWarehouseLoading = false;
          let list = res.datas||[];
          list = disposeDestinationList(list);
          this.endWarehouseList = list;
          return res;
        })
        .catch(res=>{
          this.endWarehouseLoading = false;
          this.endWarehouseList = [];
          return Promise.reject(res);
        })
    },
    /**
     * 获取 私人地址（城市）列表
     */
    getPrivateCityList(countryId="") {
      const data = {
        countryId,
      };
      let url = `/api/filedata/getCityListByCountryId`;

      this.privateCityListLoading = true;
      return this.axios.get(url, {params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.privateCityListLoading = false;
          let list = res.datas||[];
          list = disposePrivateCityList(list);
          this.privateCityList = list;
          return res;
        })
        .catch(res=>{
          this.privateCityListLoading = false;
          this.privateCityList = [];
          return Promise.reject(res);
        })

    },
    /**
     * 获取0-9邮编列表
     */
    getZipCodeList(options = {}){
      let list = createPrivateAddressZipCodeList(options);
      this.zipCodeList = list;
    },

    /**
     * 获取 货物类型下拉列表
     */
    getGoodsType(countryId="") {
      const data = {
        countryId,
      };
      let url = `/api/fbxData/getGoodsTypeByCountryId`;

      this.goodsTypeListLoading = true;
      return this.axios.get(url, {params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.goodsTypeListLoading = false;
          let list = res.datas||[];
          this.goodsTypeList = list;
          return res;
        })
        .catch(res=>{
          this.goodsTypeListLoading = false;
          this.goodsTypeList = [
            {goodsTypeName:"全部",goodsTypeId:""},
          ];
          return Promise.reject(res);
        })

    },
    /**
     * 校验 是否满足搜索条件
     * @returns {boolean}
     */
    judgeCanSearchOpenGroup(){
      if(!this.startPlace.id) {
        this.$message.error("请选择起运地");
        return false;
      }
      if(!this.endPlace.id) {
        this.$message.error("请选择目的国");
        return false;
      }
      let endWarehouse = this.endWarehouseSelectList[0]||{};
      if(!endWarehouse.id && endWarehouse.id !== 0) {
        // if(String(this.defaultProductType) === "1"){}
        // this.$message.error("请选择目的地");
        // return false;
      }
      if(!this.goodsType && this.goodsType !==0 ) {
        // this.$message.error("请选择货物类型");
        // return false;
      }
      return true
    },
    /**
     * 点击搜索
     */
    clickSearch(){
      if(!this.judgeCanSearchOpenGroup()) return false;
      // this.$emit("search",{
      //   startPlace:this.startPlace,// 起运地 {}
      //   endPlace:this.endPlace,// 目的国 {}
      //   endWarehouseList:this.endWarehouseSelectList,// 目的地 [{}]
      //   goodsTypeData,//货物类型{}
      //   goodsName: this.goodsNameCurrent, // 商品名称 String
      // })

      let startPlace = this.startPlace;// 起运地 {}
      let endPlace = this.endPlace;// 目的国 {}
      let endWarehouse = this.endWarehouseSelectList[0] || {};// 目的地 {}
      if(!endWarehouse.id || endWarehouse.id === "all") endWarehouse = {
        id:"",
        namec:"",
      }
      // let firstNumber = endPlace.namec.slice(0,1);
      // endPlace = Object.assign({},endPlace,{
      //   id: firstNumber,
      //   namec: `${firstNumber}`,
      //   namee: `${firstNumber}`,
      // })
      // let toWarehouseInfo = {
      //   address: "705 Boulder Drive Breinigsville PA 18031-1533 美国",
      //   children: null,
      //   city: "PA",
      //   cityId: null,
      //   country: "美国",
      //   countryCode: "US",
      //   countryId: 19003814200,
      //   id: 19003830500,
      //   namec: "ABE2",
      //   type: 1,
      // }
      // 起运城市代码
      let startCityCode = startPlace.code || "";
      // 目的国家代码
      let endCountryCode = endPlace.code||"";
      sendStatisticHotCountry(startCityCode,endCountryCode);

      let searchData = {
        fromCityid: startPlace.id, //起运城市id
        fromstoreName: startPlace.namec, //起运地名字
        fromCityCode: startPlace.code,//起运城市代码

        continentNameEn:endPlace.continentNameEn,//七大洲洲名称

        tocountryName: endPlace.namec, //目的国名称
        toCountryid: endPlace.countryId||endPlace.id, //目的国家id
        toCountryCode:endPlace.code,//目的国家code
        privateAddressType:endPlace.privateAddressType, //// 目的国家对应 私人地址派送类型 1:邮编 2：城市

        tostoreName: endWarehouse.namec, // 目的仓名字
        toStoreid: endWarehouse.id, // 目的仓库id
        isPrivateAddress: endWarehouse.isPrivateAddress||false,//是否是私人地址
        toWarehouseInfo: endWarehouse,//目的地信息

        goodsType:this.goodsType,
        goodsName:this.goodsNameCurrent,
        transportCodes: this.transportTypeCode[this.defaultProductType],
        podlandType: this.podlandType,
        keyword: this.keyword,
        goodNameInfo: this.goodNameInfo
      }
      this.recordCustomerOperation();
      this.submitHotSearchWord()
      this.storageKeyword()
      console.log("跳转参数",JSON.parse(JSON.stringify(searchData)));
      this.$router.push({
        name: "queryPrice",
        query: {
          searchData: JSON.stringify(searchData),
        },
      })
    },
    /**
     * 记录用户操作
     */
    recordCustomerOperation(){
      // 产品类型隐射键值对
      let productTypeMap = {
        "1":"FBA",
        "2":"海运专线",
        "3":"空运专线",
        "4":"陆运专线",
      }
      // 产品类型
      let productType = productTypeMap[this.defaultProductType];
      // 起运地 {}
      let startPlace = this.startPlace;
      // 目的国 {}
      let endPlace = this.endPlace;
      // 目的地 {}
      let endWarehouse = this.endWarehouseSelectList[0] || {};
      // 货物类型
      let goodsTypeName = "";
      if(this.goodsType){
        let goodsTypeItem = this.goodsTypeList.find(item=> item.goodsTypeId === this.goodsType);
        if(goodsTypeItem) goodsTypeName = goodsTypeItem.goodsTypeName;
      }else{
        goodsTypeName = "全部"
      }

      // `FBA,起运地XX，目的国XX，目的地XX，货物类型XX`
      let text = `${productType},起运地:${startPlace.namec},目的国:${endPlace.namec},目的地:${endWarehouse.namec},货物类型:${goodsTypeName}`;

      sendCustomerOperationRecord("查询",text);
    },
    /**
     * 产品（商品）名称 远程搜索列表方法
     * @param val
     */
    remoteMethodProductName:debounce(function (val) {
      console.log(val)
      if (val) this.getGoodsNameList(this.endPlace.id, val)
    }),
    getGoodsNameList(countryId, goodsName) {
      const params = {
        goodsName,
        countryId
      }
      this.goodsNameLoading = true
      this.axios.post('/api/FBAfee/getGoodsSurchargeByCountryAndGoodsName', params)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          console.log(res);
          let list = res.datas||[];
          this.goodsNameList = list;
          this.goodsNameLoading = false
        })
        .catch(res=>{
          this.goodsNameList = []
          this.goodsNameLoading = false
        })
    },
    /**
     * 大洲排序并删除南极洲
     * @param list
     * @param key
     */
    continentListSort(list = [], key = 'continentName') {
      const sortedContinent = ['全部', '亚洲', '欧洲', '非洲', '北美洲', '南美洲', '大洋洲']
      list = list.filter(continentItem => continentItem[key] !== '南极洲')
      list = list.sort((a, b) => {
        const index1 = sortedContinent.findIndex(item => a[key] === item)
        const index2 = sortedContinent.findIndex(item => b[key] === item)
        return index1 - index2
      })
      return list
    },
    /**
     * 获取热门关键词
     */
    getHotKeywords() {
      this.hotSearchLoading = true
      return this.axios.get('/api/hotSearch/listHotSearchCount')
        .then(res => {
          this.hotSearchNameList = res.data.datas || []
          this.hotSearchLoading = false
          return res
        }).catch(() => {
          this.hotSearchLoading = false
          this.hotSearchNameList = []
        })
    },
    changeKeyword(selectList) {
      if (!selectList.hotsearchName) return
      const keyword = selectList.hotsearchName
      this.keyword = keyword
      // this.submitHotSearchWord(keyword)
    },
    keywordInput(val) {
      this.keyword = val
    },
    keywordBlur(keyword) {
      this.keyword = keyword
    },
    submitHotSearchWord() {
      const keyword = this.selectedHotWords.hotsearchName || this.keyword
      this.keyword = keyword
      if (!keyword) return
      const params = {
        keyword,
        source: 1
      }
      this.axios.post('/api/hotSearch/insertHotSearch', params)
        .then(res => {

        })
    },
    // 搜索的关键词本地存储
    storageKeyword() {
      const keyword = this.selectedHotWords.hotsearchName || this.keyword
      if (!keyword) return
      const searchKeywordList = JSON.parse(localStorage.getItem('history-search')) || []
      const nowDate = Date.now()
      const length = searchKeywordList.length
      const keywordObj = {
        hotsearchName: keyword,
        time: nowDate
      }
      if (length) {
        const index = searchKeywordList.findIndex(item => item.hotsearchName === keyword)
        if (index !== -1) {
          searchKeywordList[index] = keywordObj
        } else {
          searchKeywordList.unshift(keywordObj)
          if (length > 11) {
            searchKeywordList.pop()
          }
        }
        searchKeywordList.sort((a, b) => -(a.time - b.time))
      } else {
        searchKeywordList.push(keywordObj)
      }
      localStorage.setItem('history-search', JSON.stringify(searchKeywordList))
    },
    goodInfoChange(good) {
      console.log(good)
      this.goodsType = good.goodType.goodsTypeId
      this.goodsNameCurrent = good.goodType.goodsTypeName
      this.goodNameInfo = good.product
    }
  },
  created() {
    this.getStartPlaceList();
    this.getContinentEndCountryList();
    this.getHotKeywords()
  },
}
</script>

<style scoped lang="scss">
$input-color:#141414;
$input-font-size:20px;
$placeholder-font-size:16px;
$input-font-weight:600;
$input-height:53px;
$input-padding:12px 20px 20px;
$select-padding-right:35px;

.home-query-product{
  font-size: 0;
  .item-space{
    margin-right: 10px;
  }

  .two-join-box{
    display: inline-flex;
    vertical-align: top;
    height: 90px;
    .join-box-item{
      &.is-left{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      &.is-right{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    .join-space{
      width: 1px;
      height: 100%;
      position: relative;
      z-index: 2;
      &--icon{
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        box-sizing: border-box;
        width: 22px;
        height: 22px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        border-radius: 50%;
        text-align: center;
        color: #BCBCBC;
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
      }
    }
  }

  .select-place-item{
    background-color: transparent;
    height: $input-height;
    /deep/ .el-input__inner{
      padding: $input-padding;
      color: $input-color;
      font-size: $input-font-size;
      font-weight: $input-font-weight;
      &::placeholder{
        font-size: $placeholder-font-size;
        font-weight: $input-font-weight;
        color: #999999;
      }
    }
    /deep/ .text-row{
      padding: 0 20px;
      color: $input-color;
      font-size: $input-font-size;
      font-weight: $input-font-weight;
    }
  }

  .select-input-box{
    /deep/ .el-input{
      &,
      &.is-disabled{
        .el-input__inner{
          border-color: transparent ;
        }
      }
    }
    /deep/ .el-input__inner{
      background-color: transparent;
      border-color: transparent ;
      border-left-width: 0;
      border-right-width: 0;
      height: $input-height;
      padding: $input-padding;
      padding-right: $select-padding-right;
      color: $input-color;
      font-size: $input-font-size;
      font-weight: $input-font-weight;

      &::placeholder{
        font-size: $placeholder-font-size;
        font-weight: initial;
      }
    }
  }
  .hide-select-arrow{
    /deep/ .el-input__suffix .el-icon-arrow-up{
      display: none;
    }
  }

  .text-input-box{
    /deep/ .el-input__inner{
      background-color: transparent;
      border-color: transparent !important;
      border-left-width: 0;
      border-right-width: 0;
      height: $input-height;
      padding: $input-padding;
      padding-right: $select-padding-right;
      color: $input-color;
      font-size: $input-font-size;
      font-weight: $input-font-weight;
      &::placeholder{
        font-size: $placeholder-font-size;
        font-weight: initial;
      }
    }
  }
  .search-btn{
    width: 198px;
    height: 87px;
    border-radius: 10px;
    vertical-align: top;

    font-size: $input-font-size;
    font-weight: 500;
  }
}
.empty-select {
  width: 195px;
  padding: 10px 0;
  margin: 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeQueryLogisticsProducts/index.vue